import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import FrontBanner from "@/assets/images/front-banner.svg";
import apiV2 from "@/middlewares/apiV2";
import { formatMoney } from "@/utils/common";
import "./index.scss";

const CongratulationPage = (props) => {
  const [paymentStatus, setPaymentStatus] = useState(null);
  const location = useLocation();
  const [confirming, setConfirming] = useState(() => new URLSearchParams(location.search).has("session_id"));
  const [from, setFrom] = useState('');
  const history = useHistory();
  // The server is authoritative on what was charged — membership discounts are applied there.
  const purchases = props.history?.location?.state?.purchases || [];

  const confirmPayment = async (sessionId) => {
    try {
      // The backend fulfils the order when it reports the session complete.
      const { data: session } = await apiV2.get("/session-status", { params: { session_id: sessionId } });

      if (session.status === "complete") {
        localStorage.removeItem("cart");
        localStorage.removeItem("checkout_from");
        localStorage.removeItem("checkout_session_id");
        setPaymentStatus({ complete: true, message: "Payment was successful!" });
      } else if (session.status === "expired") {
        setPaymentStatus({ complete: false, message: "Your checkout session expired. Please try again." });
      } else {
        setPaymentStatus({ complete: false, message: "Your payment has not been completed yet." });
      }
    } catch (error) {
      console.error("Error confirming payment:", error);
      setPaymentStatus({ complete: false, message: "Error confirming payment." });
    }
    setConfirming(false);
  };
  const takeUserToPage = () => {
    if (from === "add-sync") {
      history.replace("/userdashboard/mysyncs");
    }

    else if (from === "add-sample") {
      history.replace("/userdashboard/mysamples");
    }
    else {
      history.replace("/userdashboard/billing");
    }
  };
  useEffect(() => {
    // A Stripe redirect drops router state, so checkout leaves `from` in storage.
    setFrom(props.history?.location?.state?.from || localStorage.getItem("checkout_from") || "billing");
    const query = new URLSearchParams(location.search);
    const sessionId = query.get("session_id"); // Get session_id from the URL

    if (sessionId) {
      confirmPayment(sessionId);
    }
  }, [location.search]);



  return (
    <main className="page congrats-page">
      <div className="congrats-card">
        <div className="congrats-card__top">
          <button type="button" className="congrats-back" aria-label="Go back" onClick={() => { history.push("/") }}>
            <ArrowBackIcon />
          </button>
          <img src="https://ample-samples.s3.us-east-2.amazonaws.com/app/front-banner.svg" alt="" className="congrats-avatar" />
        </div>
        <img
          className="congrats-banner"
          src="https://ample-samples.s3.us-east-2.amazonaws.com/app/front-banner.svg"
          alt="Ample Samples"
        />
        <h1 className="congrats-title">
          {confirming
            ? "Confirming your payment…"
            : paymentStatus && !paymentStatus.complete
              ? "Your purchase is not complete"
              : "Congratulations on Your Purchase!"}
        </h1>
        {paymentStatus && (
          <p className={`congrats-status${paymentStatus.complete ? " is-complete" : ""}`} role="status">
            {paymentStatus.message}
          </p>
        )}
        <p className="congrats-text">
          Thank you for choosing Ample Samples™ for your music licensing
          and sample clearance needs. We're excited to help you
          streamline your creative process and ensure all your samples
          are cleared efficiently.
        </p>
        {purchases.length > 0 && (
          <ul className="congrats-purchases">
            {purchases.map((purchase) => (
              <li key={purchase.stripe_payment_intent_id}>
                <span>{purchase.product_name}</span>
                <strong>
                  ${formatMoney(purchase.amount)}{" "}
                  {(purchase.currency || "usd").toUpperCase()}
                </strong>
                {purchase.metadata?.credits_applied > 0 && (
                  <em> — member discount applied, 1 credit used</em>
                )}
              </li>
            ))}
          </ul>
        )}
        <button className="congrats-continue" type="button" onClick={takeUserToPage}>Continue</button>
        <p className="congrats-help">
          If you have any questions or need assistance, don’t hesitate
          to reach out to us at{" "}
          <a href="mailto:support@theamplesamples.com">support@theamplesamples.com</a>. We're here to
          support your journey every step of the way!
        </p>
      </div>
    </main>
  );
};

export default CongratulationPage;
